<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
        <v-flex xs12 sm12 md12>
            
       </v-flex>
    </v-layout>  
  </v-container>
</template>


<script>

export default {
    data() {
        return {
        }
    },
    mounted() {
      this.$nextTick(function() {
         JavaScript:window.close();
      });
    }
 };
</script> 